import * as React from 'react';
import SmartPlayerPlugin from './SmartPlayerPlugin';
import Constants from '../../globals/Constants';
import AnnotationContainer from '../Annotation/AnnotationContainer';

export default({smartPlayerInitializedPromise, storeAnnotation}: SmartPlayerAnotationPluginProps) => (
   <SmartPlayerPlugin smartPlayerInitializedPromise={smartPlayerInitializedPromise}
                                 component={<AnnotationContainer storeAnnotation={storeAnnotation} center={false}/>}
                                 pluginType={Constants.pluginType.annotation}/>
);

interface SmartPlayerAnotationPluginProps {
   smartPlayerInitializedPromise: any;
   storeAnnotation(annotation: string): void;
}
